import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { filterByLocale, promoChecker } from "@helpers/miscHelpers"
import SaleSvg from "@svgs/sale.svg"

// Shows the active Dato promotion's badge, or the default sale teardrop
const SaleBadge = () => {
  const data = useStaticQuery(graphql`
    {
      promotions: allDatoCmsPromotion(sort: { order: ASC, fields: position }) {
        nodes {
          startDate
          endDate
          name
          id
          locales
          badge {
            url
          }
        }
      }
    }
  `)

  const promos = filterByLocale(data.promotions.nodes)
  const [activePromo] = promos.filter(promo =>
    promoChecker(promo.startDate, promo.endDate, promo.locales)
  )

  if (activePromo?.badge?.url) {
    return <img src={activePromo.badge.url} alt={activePromo.name} />
  }

  return <SaleSvg />
}

export default SaleBadge
